import React, { useContext } from "react";
import styled from "styled-components";
import FormationList from "../Formation/FormationList";

const Main = styled.div`
  padding-top: 52px;
  margin-bottom: 52px;
`;

export default function () {
  return (
    <Main>
      <FormationList />
    </Main>
  );
}
